module.exports = __webpack_public_path__ + "static/media/The Joy of Computing using Python.24b1e71a.jpg";